import { BaseWidget } from "./BaseWidget";
import { ModalCoordinator } from "../modal/ModalCoordinator";
import { ProductType } from "../core/types";

export class BannerWidget extends BaseWidget {

    getBannerUrl(): string {
        if (this.contentContainer.productType === 'calculator') {
            return this.config.images.calculatorBannerUrl;
        } else {
            return this.config.images.formBannerUrl;
        }
    }

    inject(): void {
        const customCss = this.contentContainer.productType === ProductType.CALCULATOR 
            ? this.config.styles.calculator.bannerCustomCss 
            : this.config.styles.form.bannerCustomCss;
        this.contentContainer.element.innerHTML = `
        <img class="selectfi-banner-widget" src="${this.getBannerUrl()}" style="cursor: pointer; ${customCss}" />
        `;

        this.contentContainer.element.addEventListener('click', () => {
            ModalCoordinator.getInstance().open(
                this.dealerKey,
                this.options,
                this.contentContainer,
                this.iframeProvider
            );
        });
    }
}